import React, { useState } from 'react'
import {
  Button,
  Flex,
  MainHeadline,
  PageWrapper,
  Separator,
  PageFooter,
  GridWrapper,
  ItemsGrid,
  GridItem,
} from '../../styling/GlobalStyles'
import { NavBar } from '../../components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { clearWorkflowsList, deleteWorkflow, getWorkflows } from 'features/workflows/workflowsSlice'
import { setConfirmModal } from 'features/global/globalSlice'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { ModalTypes } from 'types/global.interface'
import { INameId } from 'constants/globalTypes'
import useQueryPagination from 'hooks/useQueryPagination'

export const Workflows = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { workflows, totalPages, noWorkflows } = useSelector((state: RootState) => state.workflows)
  const [params, setParams] = useState<any>(getParams({ location }))

  useQueryPagination({ fetchFunctions: [getWorkflows], cleanUpFunctions: [clearWorkflowsList], params })

  const handleDeleteWorkflow = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteWorkflow(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: workflows.length < 2,
        },
        word: 'delete workflow',
      }),
    )
  }

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Workflows...' setParams={setParams} limit={30} />
      <PageWrapper>
        <Flex between center mb='16'>
          <MainHeadline>Workflows</MainHeadline>
          <Button orange onClick={() => navigate('add')}>
            Add Workflow
          </Button>
        </Flex>
        {false ? (
          <NoItems title='Workflows' />
        ) : (
          <GridWrapper>
            <ItemsGrid columns={3}>
              {!noWorkflows ? (
                workflows.map((w: INameId) => {
                  return (
                    <GridItem key={w.id}>
                      <p onClick={() => navigate('/workflows/' + w.id)}>{w.name}</p>
                      <Flex center justcenter onClick={() => handleDeleteWorkflow(w.id)}>
                        <RemoveCircle />
                      </Flex>
                    </GridItem>
                  )
                })
              ) : (
                <NoItems title='Workflows' />
              )}
            </ItemsGrid>
          </GridWrapper>
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 5)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
